// components/common/DynamicTable.jsx
import React, { useState } from 'react';
import '../../styles/DataTable.css';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import Skeleton from "../common/Skeleton";

const DataTable = ({
                       columns,
                       data,
                       currentPage = 1,
                       itemsPerPage = 10,
                       onRowClick,
                       loading = false
                   }) => {

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? <FaSortUp/> : <FaSortDown/>;
        }
        return <FaSort/>;
    };

    const sortedData = [...data].sort((a, b) => {
        const key = sortConfig.key;
        if (!key) return 0;

        let valA = a[key];
        let valB = b[key];

        const bad = v => v === null || v === undefined || v === '' || v === '-';

        if (bad(valA) && !bad(valB)) return 1;
        if (bad(valB) && !bad(valA)) return -1;
        if (bad(valA) && bad(valB)) return 0;

        const numeric = !isNaN(valA) && !isNaN(valB);

        if (numeric) {
            return sortConfig.direction === 'ascending'
                ? Number(valA) - Number(valB)
                : Number(valB) - Number(valA);
        }

        valA = valA.toString().toLowerCase();
        valB = valB.toString().toLowerCase();

        return sortConfig.direction === 'ascending'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
    });

    return (
        <div className="table-responsive">
            <table className="table table-hover responsive custom-table">
                <thead>
                <tr>

                    {/* # Header skeleton */}
                    <th>
                        {loading
                            ? <Skeleton height={14}/>
                            : "#"}
                    </th>

                    {loading
                        ? columns.map((_, i) => (
                            <th key={i}>
                                <Skeleton height={14}/>
                            </th>
                        ))
                        : columns.map(col => (
                            <th key={col.key} onClick={() => requestSort(col.key)}>
                                <div className="header-container">
                                    <span>{col.label}</span>
                                    {getSortIcon(col.key)}
                                </div>
                            </th>
                        ))
                    }
                </tr>
                </thead>


                <tbody>

                {loading
                    ? Array.from({ length: 10 }).map((_, index) => (
                        <tr key={`skeleton-${index}`}>

                            {/* INDEX SKELETON */}
                            <td>
                                <Skeleton height={18} width={28}/>
                            </td>

                            {columns.map((_, i) => (
                                <td key={i}>
                                    <Skeleton height={20}/>
                                </td>
                            ))}
                        </tr>
                    ))

                    : sortedData.map((item, index) => (
                        <tr
                            key={item.publicId || index}
                            onClick={() => onRowClick && onRowClick(item)}
                        >
                            <td>
                                {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>

                            {columns.map(col => (
                                <td key={col.key}>
                                    {col.render
                                        ? col.render(item[col.key], item)
                                        : item[col.key]}
                                </td>
                            ))}
                        </tr>
                    ))
                }

                </tbody>
            </table>
        </div>
    );
};

export default DataTable;
